import en from './en.json'
import es from './es.json'

export default {
  en,
  es,
}

export const availableLanguages = [
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
]

export const languageNativeNames = {
  ar: 'العربية',
  cs: 'Čeština',
  de: 'Deutsch',
  en: 'English',
  es: 'Español',
  fr: 'Français',
  he: 'עברית',
  id: 'Indonesian',
  it: 'Italiano',
  ja: '日本語',
  ko: '한국어',
  ms: 'Melayu',
  nl: 'Nederlands',
  pl: 'Polski',
  'pt-BR': 'Português (Brasil)',
  pt: 'Português (Portugal)',
  ru: 'Русский',
  sk: 'Slovenčina',
  th: 'ไทย',
  tr: 'Türkçe',
  uk: 'Українська',
  vi: 'Tiếng Việt',
  'zh-Hans': '中文 (简体)',
  zh: '中文 (繁體)',
}